<template>
  <div class="ibir-cont">

    <!-- Matrix block -->
    <div class="ibir-matrix" v-if="show_matrix">
      <h2 class="ibir">Matriz</h2>
      <RiskMatrix
        :metrics="metrics"
        :metrics_formula="metrics_formula"
        :interpreter="interpreter"
      />
    </div>

    <!-- Risk table block -->
    <div class="ibir-intertable-cont">
      <h2 class="ibir">Tabla del riesgo</h2>
      <RiskTable :interpreter="interpreter" />
    </div>

    <!-- Metrics block -->
    <div class="ibir-metrics">
      <h2 class="ibir">Criterios</h2>
      <IndicatorMetrics :metrics="metrics" />
    </div>

    <!-- Formula block -->
    <div class="ibir-formula">
      <h2 class="ibir">Fórmula</h2>
      <IndicatorFormula :metrics="metrics" :metrics_formula="metrics_formula" />
    </div>

    <!-- DEBUGGING -->
    <!-- <div>{{ JSON.stringify(props) }}</div> -->
  </div>
</template>


<style lang="scss">
 @import '@/sass/variables.scss';
 @import '@/sass/explorer.scss';
 @import '@/sass/explorer/inline.scss';

 $table-border-color: #666;
 $table-bw: 1px; /*border width*/

 .ibir-cont {
   width: 100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   gap: 24px 64px;
   padding: 0px 8px 8px 8px;
 }

 .ibir-fullwidth {
   width: 100%;
 }

 h2.ibir {
   @extend .data-inline-expand-title;
   padding: 16px 8px 8px 0px;
   font-size: 20px;
 }

 .ibir-metrics {
   width: 340px !important;
 }
</style>


<script>
 import RiskMatrix from '@/components/indicator/RiskMatrix.vue';
 import RiskTable from '@/components/indicator/RiskTable.vue';
 import IndicatorFormula from '@/components/indicator/IndicatorFormula.vue';
 import IndicatorMetrics from '@/components/indicator/IndicatorMetrics.vue';

 export default {
   name: 'InlineBoxIndicatorRisk',

   props: {
     current_qunit: Object,
     props: Object,
     is_mobile: {type: Boolean, default: false},
   },

   components: {
     RiskMatrix,
     RiskTable,
     IndicatorFormula,
     IndicatorMetrics,
   },

   data: (() => ({
   })),

   mounted() {
   },

   computed: {
     metrics() {
       return this.props.metrics;
     },

     metrics_formula() {
       return this.props.metrics_formula;
     },

     interpreter() {
       return this.props.interpreter;
     },

     show_matrix() {
       return (
         this.metrics.length <= 2
         && !this.metrics.some(m => (m.type != 'category'))
       );
     },
   },

   methods: {
   },
 }
</script>
